module.exports = __webpack_public_path__ + "static/media/dinin.3c9477b5.jpeg";